export type ActivityView = 'important' | 'all' | 'action' | 'following'
export type ActivityTime = 'today' | 'yesterday' | 'earlier'

export interface ActivityQuery {
  view?: ActivityView
  projectId?: string
  scope?: 'account' | 'project' | 'conversation'
  type?: string
  status?: string
  actor?: string
  q?: string
  time?: ActivityTime
  before?: string
  limit?: number
}

export function activityTimeBounds(time: ActivityTime | undefined, now = new Date()): {
  occurredAfter?: string
  occurredBefore?: string
} {
  if (!time) return {}
  const today = new Date(now)
  today.setHours(0, 0, 0, 0)
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  if (time === 'today') return { occurredAfter: today.toISOString() }
  if (time === 'yesterday') {
    return { occurredAfter: yesterday.toISOString(), occurredBefore: today.toISOString() }
  }
  return { occurredBefore: yesterday.toISOString() }
}
